(() => {
  const normalize = (text) => (text || '').toLocaleLowerCase('de').normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
  const classify = (title) => {
    const t = normalize(title);
    const combined = /(?:dc\s*[/+\-]\s*ac|ac\s*[/+\-]\s*dc)/.test(t);
    const ac = /(?:^|[^a-z])ac(?:$|[^a-z])/.test(t);
    const dc = /(?:^|[^a-z])dc(?:$|[^a-z])/.test(t);
    const strings = t.match(/(?:^|[^\d])([1-4])\s*[- ]?\s*strings?\b/);
    return {
      power: combined ? 'combined' : (dc && !ac ? 'dc' : (ac && !dc ? 'ac' : 'unknown')),
      strings: strings ? strings[1] : '',
      lasttrenn: /lastrennschalt|lasttrennschalt|lastrenschalt|lasttrenschalt/.test(t),
      meter: /stromzahler|energiezahler|\bmid\b/.test(t)
    };
  };

  const init = (root) => {
    const cards = [...root.querySelectorAll('[data-amk-product]')];
    const filters = [...root.querySelectorAll('[data-amk-filter]')];
    const count = root.querySelector('[data-amk-count]');
    const empty = root.querySelector('[data-amk-empty]');
    const catalog = root.querySelector('.amk-solar__catalog');
    cards.forEach((card) => { card.amkCategory = classify(card.dataset.amkTitle); });

    const apply = (selected, scroll) => {
      let shown = 0;
      cards.forEach((card) => {
        const c = card.amkCategory;
        const visible = selected === 'all' ||
          (selected === 'dc' && c.power === 'dc') ||
          (selected === 'ac-combined' && (c.power === 'ac' || c.power === 'combined')) ||
          (['1', '2', '3', '4'].includes(selected) && c.strings === selected) ||
          (selected === 'lasttrenn' && c.lasttrenn) ||
          (selected === 'meter' && c.meter);
        card.hidden = !visible;
        if (visible) shown++;
      });
      filters.forEach((button) => {
        const active = button.dataset.amkFilter === selected;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      count.textContent = String(shown);
      empty.hidden = shown !== 0;
      if (scroll) catalog.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-amk-filter], [data-amk-type], [data-amk-string], [data-amk-feature]');
      if (!trigger || !root.contains(trigger)) return;
      const selected = trigger.dataset.amkFilter || trigger.dataset.amkType || trigger.dataset.amkString || trigger.dataset.amkFeature;
      event.preventDefault();
      apply(selected, trigger.tagName === 'A');
    });
    apply('all', false);
  };
  const start = () => document.querySelectorAll('[data-amk-solar]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
